// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PremiumFeatureBanner_wrapper__yPCkH"};